































import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import Vue from 'vue';
import BetBuilderSummaryFooter from '../shared/components/BetBuilderSummaryFooter.vue';
import BetBuilderSummaryHeader from '../shared/components/BetBuilderSummaryHeader.vue';
import BetBuilderSummaryEventCard from '../shared/components/BetBuilderSummaryEventCard.vue';
import { BetBuilderPreviewSummary } from '../types/BetBuilderPreview';

export default defineComponent({
    name: 'BetBuilderSummary',
    emits: [
        'clear',
        'create',
    ],
    props: {
        selectionsCount: {
            type: Number,
            required: true,
        },
        inactiveSelectionsCount: {
            type: Number,
            required: true,
        },
        isSelectionInactive: {
            type: Boolean,
            required: true,
        },
        summary: {
            type: Object as PropType<BetBuilderPreviewSummary>,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        isTicketCheckVisible: {
            type: Boolean,
            required: true,
        },
        isCreateInProgress: {
            type: Boolean,
            required: true,
        },
        isPreviewLoading: {
            type: Boolean,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        return {
            totalOddsPrice: computed(() => Number(Vue.prototype.$formatOddValue(props.summary.price))),
        };
    },
    components: {
        BetBuilderSummaryFooter,
        BetBuilderSummaryHeader,
        BetBuilderSummaryEventCard,
    },
});
